import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RobitoLogo from "../components/RobitoLogo";
import "../App.css";
import { apiPostPublic} from "../utils/api";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(0); // countdown timer

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      // Make API call to register.php
      const response = await apiPostPublic("send_reset_password.php", {
        email: email,
      });


      if (response.result === 1) {
        setMessage("A reset link has been sent to your email. Please check your inbox (including spam folder)");
        setCountdown(100); // start countdown
      } else {
        setError(response.message || "Failed to send reset link. Please try again.");
      }
    } catch (error) {
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Countdown logic
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <RobitoLogo />
        <h2 className="form-title">Reset Password</h2>
        <form onSubmit={handleSubmit} className="form-container">
          <input
            type="email"
            placeholder="Enter your email address"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            className="primary-button"
            disabled={loading || countdown > 0}
          >
            {loading
              ? "Sending..."
              : countdown > 0
              ? `Resend in ${countdown}s`
              : "Send Reset Link"}
          </button>
        </form>

        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}

        <p className="form-footer">
          Remember your password? <Link to="/" className="link">Login</Link>
        </p>
        <div className="copyright">© Robito.Ai 2025</div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
